import { render } from "./RemoteData.vue?vue&type=template&id=4e839692&scoped=true"
import script from "./RemoteData.vue?vue&type=script&lang=js"
export * from "./RemoteData.vue?vue&type=script&lang=js"

import "./RemoteData.vue?vue&type=style&index=0&id=4e839692&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e839692"]])

export default __exports__